import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { Product } from "src/app/modals/product.model";
import { SwiperDirective } from "ngx-swiper-wrapper";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { MatDialog, MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import { ProductDialogComponent } from "../../products/product-dialog/product-dialog.component";
import { CartService } from "src/app/components/shared/services/cart.service";
import { ProductService } from "src/app/components/shared/services/product.service";
import { WishlistService } from "src/app/components/shared/services/wishlist.service";
import { environment } from "src/environments/environment";
import { ItemsService } from "src/app/services/items.service";
import { AlertServiceService } from "src/app/services/alerta.service";

@Component({
  selector: "app-product-carousel",
  templateUrl: "./product-carousel.component.html",
  styleUrls: ["./product-carousel.component.sass"],
})
export class ProductCarouselComponent implements OnInit {
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
  // @Output() onClick = new EventEmitter<any>();
  @Input("product") product: Array<Product> = [];
  @Input()
  set tipo(value: any) {
    this._tipo = value;
  }
  // @Input()
  // set product(value:any){
  //   this.dataStorage = environment.dataStorage;
  //   this._product = value;
  // }
  public config: SwiperConfigInterface = {};
  public _product: any;
  private loader: boolean = true;
  private _tipo: any = "1";

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private cartService: CartService,
    private productService: ProductService,
    private wishlistService: WishlistService,
    public snackBar: MatSnackBar,
    public itemService: ItemsService,
    private alert: AlertServiceService
  ) {
  }
  ngOnInit(
  
  ) {
  }

  ngAfterViewInit() {
   setTimeout(() => {
    this.config = {
      observer: true,
      slidesPerView: 5,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        740: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },
      },
    };
   }, 1500);
  }

  public openProductDialog(product) {
    let dialogRef = this.dialog.open(ProductDialogComponent, {
      data: product,
      panelClass: "product-dialog",
    });
  }

  // Add to cart
  public addToCart(product: any, quantity: number = 1) {
    if (product.SaldoG == 0) {
      this.snackBar.open(product.NombreItm + " no cuenta con stock", "×", {
        panelClass: "error",
        verticalPosition: "top",
        duration: 4000,
      });
      return false;
    }

    if (sessionStorage.getItem("tp") == null) {
      sessionStorage.setItem("tp", "TA");
      product.PVVenta = product.PV2;
    } else {
      if (sessionStorage.getItem("tp") == "TA") {
        product.PVVenta = product.PV2;
      } else {
        product.PVVenta = product.PV3;
      }
    }
    // ////console.log(_product);
    this.cartService.addToCart(product, quantity);
    document.getElementById("carritoDialog").click();
    // this.alert.abrirCarrito()
  }

  // Add to wishlist
  public addToWishlist(product: Product) {
    this.wishlistService.addToWishlist(product);
  }

  // Add to compare
  public addToCompare(product: Product) {
    this.productService.addToCompare(product);
  }
  async cargarProducto(item) {
    // console.log(item)
    if (this._tipo == 1) {
      await this.itemService.sumarClic(item.idItemEC);
      this.router.navigate(["/home/product", item.idItemEC]);
    } else {
      this.onOpenProductDialog.emit(item);
    }
    //[routerLink]="['/home/product', product.idItem]"
    // this.onOpenProductDialog.emit(item.idItem)
    // window.location.reload();
  }
  enviarMensajeWsp(product) {
    // console.log(this.productItem)
    const formData = {
      name: "Prueba",
      phone: "933288799",
      url: "novaplaza.pe/%23/home/product/967",
      date:
        "%0ACodigo: " +
        product.CodigoBarras +
        "%0ANombre Item: " +
        product.NombreItm +
        "%0AUrl: novaplaza.pe/%23/home/product/" +
        product.idItem,
    };

    const URL = `https://api.whatsapp.com/send?phone=${formData.phone}&text=Hola busco este Producto,%20${formData.date}%20&source=&data=`;
    window.open(URL, "_blank");
  }
}
